import React, { useState } from 'react';
import {
  Box, Container, Card, CardContent, TextField, Button, Typography, Stack, Alert,
  IconButton, InputAdornment,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useApp } from '../context/AppContext';
import Logo from '../components/Logo';
import TelefonoInput from '../components/TelefonoInput';

export default function Login() {
  const { loginBackend } = useApp();
  const navigate = useNavigate();

  const [indicativo, setIndicativo] = useState('57');   // Colombia
  const [numero, setNumero]         = useState('');
  const [e164, setE164]             = useState('');
  const [telValido, setTelValido]   = useState(false);
  const [contrasena, setContrasena] = useState('');
  const [mostrar, setMostrar]       = useState(false);
  const [error, setError]           = useState('');
  const [cargando, setCargando]     = useState(false);

  const enviar = async (e) => {
    e?.preventDefault?.();
    setError('');
    if (!telValido) {
      setError('Escribe un número de teléfono válido.');
      return;
    }
    if (!contrasena.trim()) {
      setError('Escribe tu contraseña.');
      return;
    }
    setCargando(true);
    try {
      const res = await loginBackend(e164, contrasena);
      // Redirigir según el rol
      switch (res.entidadTipo) {
        case 'SUPERADMIN':    navigate('/admin', { replace: true }); break;
        case 'INVERSIONISTA': navigate('/proyecto', { replace: true }); break;
        case 'NEGOCIO':       navigate('/negocio', { replace: true }); break;
        case 'VECI':          navigate('/veci', { replace: true }); break;
        case 'DOMICILIARIO':  navigate('/domiciliario', { replace: true }); break;
        case 'GUIA':          navigate('/guia', { replace: true }); break;
        default:              navigate('/', { replace: true });
      }
    } catch (err) {
      setError(err.mensajeUsuario || 'Teléfono o contraseña incorrectos.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FBF7F0', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="lg" sx={{ py: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton onClick={() => navigate('/')} aria-label="Volver">
          <ArrowBackIcon />
        </IconButton>
        <Logo />
      </Container>

      <Container maxWidth="sm" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', py: 4 }}>
        <Card sx={{ width: '100%' }}>
          <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
            <Typography variant="overline" color="text.secondary">Inicia sesión</Typography>
            <Typography variant="h4" sx={{ fontFamily: 'Fraunces', mb: 1 }}>
              Hola de nuevo
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              Entra con tu teléfono y contraseña, ya sea que estés registrado como negocio, como veci o como administrador.
            </Typography>

            <form onSubmit={enviar}>
              <Stack spacing={2.5}>
                <TelefonoInput
                  indicativo={indicativo}
                  numero={numero}
                  autoFocus
                  disabled={cargando}
                  onChange={(ind, num, compuesto, valido) => {
                    setIndicativo(ind);
                    setNumero(num);
                    setE164(compuesto);
                    setTelValido(valido);
                  }}
                />
                <TextField
                  label="Contraseña"
                  type={mostrar ? 'text' : 'password'}
                  value={contrasena}
                  onChange={(e) => setContrasena(e.target.value)}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setMostrar((v) => !v)} edge="end" size="small">
                          {mostrar ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {error && <Alert severity="error">{error}</Alert>}

                <Button type="submit" variant="contained" size="large" fullWidth disabled={cargando}>
                  {cargando ? 'Entrando…' : 'Entrar'}
                </Button>

                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    component="button"
                    type="button"
                    onClick={() => navigate('/solicitar-reset')}
                    sx={{
                      background: 'none', border: 'none', cursor: 'pointer',
                      color: 'primary.main', fontSize: 14, textDecoration: 'underline',
                      '&:hover': { color: 'primary.dark' },
                    }}
                  >
                    ¿Olvidaste tu contraseña?
                  </Typography>
                </Box>

                <Box sx={{ textAlign: 'center', pt: 1 }}>
                  <Typography variant="body2" color="text.secondary" component="span">
                    ¿No tienes cuenta?{' '}
                  </Typography>
                  <Typography
                    component="button"
                    type="button"
                    onClick={() => navigate('/registro')}
                    sx={{
                      background: 'none', border: 'none', cursor: 'pointer',
                      color: 'primary.main', fontSize: 14, textDecoration: 'underline', fontWeight: 600,
                      '&:hover': { color: 'primary.dark' },
                    }}
                  >
                    Regístrate
                  </Typography>
                </Box>
              </Stack>
            </form>
          </CardContent>
        </Card>
      </Container>

      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="caption" color="text.secondary">
          HolaVeci · Redeprog SAS
        </Typography>
      </Box>
    </Box>
  );
}
